import React, { useEffect, useState } from "react";
import Router, { useRouter } from "next/router";
import Container from "../Container";
import {
  AwardsContainer,
  AwardsDontMissDay,
  AwardsImg,
  AwardsItem,
  AwardsList,
  AwardsProgress,
  AwardsTitle,
  AwardsWrapper,
  CurrentYearWrapper,
  DailyPlayWrapper,
  NextYearButton,
  PlayNowButton,
  PrevYearButton,
  Text,
  Title,
  Year,
} from "./AwardsContent.component";
import useTranslation, { useRoutes } from "../../helpers/translationTexts/useTranslation";
import { Award } from "../../types/awards";
import SyncManager from "../../api/SyncManager";
import SidePanel from "../SidePanel";
import { useSession } from "../../context/SessionProvider";
import calculateSelectedMonth from "../../helpers/calculateSelectedMonth";

const AwardsContent: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState<number>(currentYear);
  const [userAwardsData, setUserAwardsData] = useState<Award[]>([]);
  const dailyRoute = useRoutes().DailySudoku;
  const langPath = useRouter().asPath.split("/")[1];
  const { setSelectMonth } = useSession();
  const routerDailySudoku = useRoutes().DailySudoku;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const awards = await SyncManager.loadAnnualAwards(String(year), langPath);
        setUserAwardsData(awards);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };
    fetchData();
  }, [langPath, year]);

  const handleYearChange = (incr: number) => {
    setYear((prevYear) => prevYear + incr);
  };

  const nextButtonDisabled: boolean = year >= currentYear;
  const prevButtonDisabled: boolean = year === 2022;

  const handleRedirectPlaySudoku = () => {
    Router.push(dailyRoute);
  };

  return (
    <Container>
      <AwardsContainer>
        <AwardsWrapper>
          <Title>{useTranslation("yourAwards")}</Title>
          <Text routerDailySudoku={routerDailySudoku} textLink={useTranslation("getAwards")}>
            {useTranslation("yourAwardsDescription")}
          </Text>
          <CurrentYearWrapper>
            <PrevYearButton handleYearChange={handleYearChange} isDisable={prevButtonDisabled} />
            <Year currentYear={year} />
            <NextYearButton handleYearChange={handleYearChange} isDisable={nextButtonDisabled} />
          </CurrentYearWrapper>
          <AwardsList>
            {userAwardsData.map((award) => (
              <AwardsItem
                key={award.month}
                onClick={() => {
                  setSelectMonth(calculateSelectedMonth(award.svgPath));
                  Router.push(routerDailySudoku);
                }}
              >
                <AwardsImg
                  src={`/images/cup/${award.progress >= 99 ? "received" : "shade"}/${award.svgPath}.svg`}
                  alt="cup"
                />
                <AwardsProgress progress={award.progress} />
                <AwardsTitle title={award.month} />
              </AwardsItem>
            ))}
          </AwardsList>
          <CurrentYearWrapper>
            <PrevYearButton handleYearChange={handleYearChange} isDisable={prevButtonDisabled} />
            <Year currentYear={year} />
            <NextYearButton handleYearChange={handleYearChange} isDisable={nextButtonDisabled} />
          </CurrentYearWrapper>
          <DailyPlayWrapper>
            <AwardsDontMissDay title={useTranslation("awardsDontMissASingleDay")} />
            <PlayNowButton onClick={handleRedirectPlaySudoku}>{useTranslation("playNow")}</PlayNowButton>
          </DailyPlayWrapper>
        </AwardsWrapper>
        <SidePanel />
      </AwardsContainer>
    </Container>
  );
};

export default AwardsContent;
